import React from 'react';

const WidgetYoutube = ({width = 20, height = 20, couleur = "#A8B0B3"}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 40 40" fill="none">
        <path
            d="M12.4141 4.53287C12.4141 3.67609 13.4211 3.21604 14.0688 3.77699L31.9262 19.2443C32.3865 19.6431 32.3865 20.3573 31.9261 20.7561L14.0688 36.2234C13.4211 36.7844 12.4141 36.3243 12.4141 35.4675V4.53287Z"
            stroke={couleur} strokeWidth="4" strokeLinejoin="round"/>
    </svg>
);

export default WidgetYoutube;
